export default __webpack_public_path__ + "static/HOGAR_S2-7eb49293be77a7cea7ffaaa546b8ff70.png";